<div class="project-cost-container">
  <div class="form-style project-cost-generic-styling">
    <form class="project-cost-generic-styling">
      <dx-validation-group>
        <dx-form
          #form
          [readOnly]="false"
          [showColonAfterLabel]="true"
          [formData]="focusedSelection"
          class="form-style-container project-cost-pop-up-width"
          [colCount]="2"
          [validationGroup]="validationGroupName"
        >
          <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
            <dxi-item [colSpan]="2" width="100%">
              <div *dxTemplate="let data of 'detailsAndCostsTemplate'" class="payment-plan-container">
                <div class="payment-container cost-details-card">
                  <div class="payment-plan-header full-width" i18n="@@costDetails">Cost Details</div>

                  <div class="cost-details-columns">
                    <div class="cost-details-column">
                      <dx-form [validationGroup]="validationGroupName">
                        <dxi-item itemType="group" [colSpan]="2" [colCount]="popupCol > 1 ? popupCol / 2 : popupCol">
                          <dxi-item
                            [colSpan]="4"
                            template="treeListDropDownTemplate"
                            [dataField]="focusedSelection.siteCost.projectCostCategoryId"
                            [isRequired]="true"
                          >
                            <dxo-label i18n-text text="Category"></dxo-label>
                            <div
                              *dxTemplate="let data of 'treeListDropDownTemplate'"
                              class="extra-padding-for-pop-up"
                              [class.contact-icon-reserved]="showContactIcons"
                            >
                              <dx-drop-down-box
                                [(value)]="focusedSelection.siteCost.projectCostCategoryId"
                                [inputAttr]="{ 'aria-label': 'Owner' }"
                                [(opened)]="isTreeBoxOpened"
                                valueExpr="id"
                                displayExpr="categoryName"
                                i18n-placeholder
                                placeholder="Select a category..."
                                [showClearButton]="true"
                                [dataSource]="treeDataSourceSorted"
                                [disabled]="categoryDisabled"
                                [showDropDownButton]="true"
                              >
                                <dx-validator>
                                  <dxi-validation-rule
                                    type="required"
                                    i18n-message="@@categoryIsRequired"
                                    message="Category is required"
                                  >
                                  </dxi-validation-rule>
                                </dx-validator>

                                <div *dxTemplate="let data of 'content'">
                                  <dx-tree-view
                                    [dataSource]="treeDataSourceSorted"
                                    dataStructure="plain"
                                    keyExpr="treeId"
                                    parentIdExpr="treeCategoryId"
                                    selectionMode="single"
                                    displayExpr="categoryName"
                                    [selectByClick]="true"
                                    [searchEnabled]="true"
                                    (onItemSelectionChanged)="treeView_itemSelectionChanged($event)"
                                    (onInitialized)="treeView_itemSelectionChanged($event)"
                                  >
                                  </dx-tree-view>
                                </div>
                              </dx-drop-down-box>
                              @if (missingRoleDepartment; as department) {
                                <p class="missing-role-hint" role="alert">
                                  <app-svg-icon icon="alert" [size]="16" color="#f4b400"></app-svg-icon>
                                  <span i18n="@@costMissingResponsibleRole">Please assign a responsible person for the department {{ department }} in the project roles first.</span>
                                </p>
                              }
                            </div>
                            <dxi-validation-rule
                              type="required"
                              i18n-message="@@categoryIsRequired"
                              message="Category is required"
                            >
                            </dxi-validation-rule>
                          </dxi-item>

                          <dxi-item
                            [colSpan]="4"
                            [dataField]="focusedSelection.siteCost.partnerId"
                            [isRequired]="false"
                          >
                            <dxo-label i18n-text="@@serviceProvider" text="Service Provider"></dxo-label>
                            <div
                              *dxTemplate="let data of 'partnerTemplate'"
                              class="partner-width"
                              [class.contact-icon-reserved]="
                                showContactIcons && !focusedSelection.siteCost.partnerId
                              "
                            >
                              <app-contacts-dropdown-box
                                class="test contact-field-input"
                                [(contactId)]="focusedSelection.siteCost.partnerId"
                                [(contactType)]="focusedSelection.siteCost.partnerType"
                                [companies]="companies"
                                [persons]="persons"
                                (onContactSelected)="onDropdownContactSelected($event, data)"
                                (onNewContactRequested)="onNewContactFromDropdown($event, data, 'partner')"
                                [validationRequired]="false"
                                [validationGroup]="''"
                              >
                              </app-contacts-dropdown-box>
                              <app-gpd-button
                                *ngIf="focusedSelection.siteCost.partnerId"
                                class="contact-view-button"
                                type="text"
                                icon="user"
                                i18n-hint="@@viewContact"
                                hint="View contact"
                                (onClick)="
                                  viewContact(
                                    focusedSelection.siteCost.partnerId,
                                    focusedSelection.siteCost.partnerType
                                  )
                                "
                              >
                              </app-gpd-button>
                            </div>
                            <!--                             <dxi-validation-rule type="required" i18n-message="@@partnerIsRequired"
                                        message="Partner is required">
                                    </dxi-validation-rule> -->
                          </dxi-item>

                          <dxi-item [colSpan]="4" [dataField]="focusedSelection.siteCost.debitorId" [isRequired]="true">
                            <dxo-label i18n-text text="Debitor"></dxo-label>
                            <div
                              *dxTemplate="let data of 'debitorTemplate'"
                              class="debitor-width"
                              [class.contact-icon-reserved]="
                                showContactIcons && !focusedSelection.siteCost.debitorId
                              "
                            >
                              <app-contacts-dropdown-box
                                class="test contact-field-input"
                                [(contactId)]="focusedSelection.siteCost.debitorId"
                                [(contactType)]="focusedSelection.siteCost.debitorType"
                                [companies]="companies"
                                [persons]="persons"
                                [tagFilter]="true"
                                (onContactSelected)="onDropdownDebitorContactSelected($event, data)"
                                (onNewContactRequested)="onNewContactFromDropdown($event, data, 'debitor')"
                                [validationRequired]="true"
                                [validationMessage]="debitorRequiredMessage"
                                [validationGroup]="validationGroupName"
                              >
                              </app-contacts-dropdown-box>
                              <app-gpd-button
                                *ngIf="focusedSelection.siteCost.debitorId"
                                class="contact-view-button"
                                type="text"
                                icon="user"
                                i18n-hint="@@viewContact"
                                hint="View contact"
                                (onClick)="
                                  viewContact(
                                    focusedSelection.siteCost.debitorId,
                                    focusedSelection.siteCost.debitorType
                                  )
                                "
                              >
                              </app-gpd-button>
                            </div>
                          </dxi-item>

                        </dxi-item>
                      </dx-form>
                    </div>

                    <div class="cost-details-column">
                      <dx-form [validationGroup]="validationGroupName">
                        <dxi-item itemType="group" [colSpan]="2" [colCount]="popupCol > 1 ? popupCol / 2 : popupCol">
                          <dxi-item [colSpan]="4" [isRequired]="true">
                            <dxo-label i18n-text="@@nettCost" text="Nett Cost"></dxo-label>
                            <div *dxTemplate="'nettCostTemplate'">
                              <dx-number-box
                                (onValueChanged)="onSiteNettCostOrUstChange()"
                                [(value)]="focusedSelection.siteCost.totalCostNett"
                                format="#,##0.00 €"
                              >
                                <dx-validator>
                                  <dxi-validation-rule
                                    [validationCallback]="validateNonZero"
                                    type="custom"
                                    i18n-message="@@nettCostRequired"
                                    message="Nett Cost required"
                                  >
                                  </dxi-validation-rule>
                                </dx-validator>
                              </dx-number-box>
                            </div>
                            <dxi-validation-rule
                              [validationCallback]="validateNonZero"
                              type="custom"
                              i18n-message="@@nettCostRequired"
                              message="Nett Cost required"
                            >
                            </dxi-validation-rule>
                          </dxi-item>

                          <dxi-item [colSpan]="4">
                            <dxo-label i18n-text="@@vat" text="VAT"></dxo-label>
                            <div *dxTemplate="'vatTemplate'">
                              <dx-number-box
                                (onValueChanged)="onSiteNettCostOrUstChange()"
                                format="#,##0.# %"
                                [(value)]="focusedSelection.siteCost.ust"
                              >
                              </dx-number-box>
                            </div>
                          </dxi-item>
                          <dxi-item [colSpan]="4">
                            <dxo-label i18n-text="@@grossCost" text="Gross Cost"></dxo-label>
                            <div *dxTemplate="'groeeCOstTemplate'">
                              <dx-number-box
                                [(value)]="focusedSelection.siteCost.totalCostGross"
                                class="read-only"
                                format="#,##0.00 €"
                                [readOnly]="true"
                              >
                              </dx-number-box>
                            </div>
                          </dxi-item>
                          <dxi-item [colSpan]="3">
                            <dxo-label i18n-text="@@paymentType" text="Payment Type"></dxo-label>
                            <div *dxTemplate="'typeTemplate'">
                              <div class="width-value-cost">
                                <div class="switch-container">
                                  <div
                                    class="switch"
                                    [ngClass]="{
                                      active: focusedSelection.siteCost.planIsPercentage === true,
                                    }"
                                    id="toggleSwitch"
                                    (click)="toggleSwitch()"
                                  >
                                    <span i18n="@@euro">Euro</span>
                                    <span i18n="@@percent">Percent</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </dxi-item>
                          <dxi-item [colSpan]="3">
                            <dxo-label i18n-text="@@commissioned" text="Commissioned"></dxo-label>
                            <div *dxTemplate="'beauftragtTemplate'">
                              <dx-check-box [(value)]="focusedSelection.siteCost.beauftragt"></dx-check-box>
                            </div>
                          </dxi-item>
                        </dxi-item>
                      </dx-form>
                      <!--          <div class="full-width-cost">

                                  <div class="cost-card-label-value-container">
                                      <div i18n="@@nettCost" class="width-label-cost"> Nett Cost:
                                      </div>
                                      <div class="width-value-cost">
                                          <dx-number-box (onValueChanged)="onSiteNettCostOrUstChange()"
                                              [(value)]="focusedSelection.siteCost.totalCostNett" format="#,##0.00 €">
                                              <dx-validator>
                                                  <dxi-validation-rule [validationCallback]="validateNonZero"
                                                      type="custom" i18n-message="@@nettCostRequired"
                                                      message="Nett Cost required">
                                                  </dxi-validation-rule>

                                              </dx-validator>
                                          </dx-number-box>
                                      </div>
                                  </div>

                                  <div class="cost-card-label-value-container">
                                      <div i18n="@@vat" class="width-label-cost"> VAT: </div>
                                      <div class="width-value-cost">
                                          <dx-number-box (onValueChanged)="onSiteNettCostOrUstChange()" format="#,##0.# %"
                                              [(value)]="focusedSelection.siteCost.ust">
                                          </dx-number-box>
                                      </div>
                                  </div>
                                  <div class="cost-card-label-value-container">
                                      <div i18n="@@grossCost" class="width-label-cost">Gross Cost:
                                      </div>
                                      <div class="width-value-cost">
                                          <dx-number-box [(value)]="focusedSelection.siteCost.totalCostGross"
                                              class="read-only" format="#,##0.00 €" [readOnly]="true">

                                          </dx-number-box>
                                      </div>
                                  </div>
                                  <div class="cost-card-label-value-container">
                                      <div i18n="@@paymentType" class="width-label-cost">
                                          Payment Type:
                                      </div>

                                      <div class="width-value-cost">
                                          <div class="switch-container">
                                              <div class="switch"
                                                  [ngClass]="{'active': focusedSelection.siteCost.planIsPercentage === true}"
                                                  id="toggleSwitch" (click)="toggleSwitch()">
                                                  <span>Euro</span>
                                                  <span>Percent</span>
                                                  <div class="slider"></div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </dxi-item>
          </dxi-item>

          <dxi-item
            *ngIf="addPaymentPlanVisible"
            itemType="group"
            [colSpan]="2"
            [colCount]="2"
          >
            <dxi-item [colSpan]="2" width="100%">
              <div *dxTemplate="let data of 'zahlplanTemplate'">
                <ng-container
                  *ngFor="
                    let item of focusedSelection.paymentPlans;
                    let i = index
                  "
                >
                  <div *ngIf="!item.isDeleted" class="payment-plan-container">
                    <div class="payment-container">
                      <div class="payment-plan-header">
                        <div
                          *ngIf="
                            removePaymentPlanButtonVisible === true &&
                            item.planNr !== '' &&
                            item.planNr !== null
                          "
                          [innerHTML]="item.planNr + '. '"
                        ></div>
                        <div [innerHTML]="invoiceText(item.planNr)"></div>
                      </div>
                      <div class="card-inner-container">
                        <div class="left-card-item-container">
                          <div class="left-card-label-value-container">
                            <div i18n="@@invoiceAvailable" class="width-label">
                              Invoice available:
                            </div>
                            <dx-check-box
                              [(value)]="item.invoiceAvailable"
                              (onValueChanged)="onInvoiceAvailableChanged(item, invoiceNumberValidator)"
                            ></dx-check-box>
                          </div>

                          <div class="left-card-label-value-container">
                            <div i18n="@@invoiceNumber" class="width-label">
                              Invoice Number:
                            </div>
                            <dx-text-box
                              class="width-value"
                              [(value)]="item.invoiceNumber"
                              valueChangeEvent="input"
                              (onValueChanged)="onInvoiceNumberChanged(item, $event)"
                              [maxLength]="100"
                            >
                              <dx-validator #invoiceNumberValidator [validationGroup]="validationGroupName">
                                <dxi-validation-rule
                                  type="custom"
                                  [reevaluate]="true"
                                  [validationCallback]="invoiceNumberRule(item)"
                                  i18n-message="@@invoiceNumberRequired"
                                  message="Invoice number is required when an invoice is available"
                                >
                                </dxi-validation-rule>
                              </dx-validator>
                            </dx-text-box>
                          </div>

                          <div class="left-card-label-value-container">
                            <div i18n="@@percent" class="width-label">
                              Percent:
                            </div>
                            <dx-number-box
                              class="width-value read-only"
                              [(value)]="item.planPercentage"
                              [readOnly]="
                                !focusedSelection.siteCost.planIsPercentage
                              "
                              (onValueChanged)="onPlanPercentageChange(i)"
                              [min]="0"
                              [max]="100"
                              format="#,##0.# %"
                            >
                              <dx-validator>
                                <dxi-validation-rule
                                  type="custom"
                                  [validationCallback]="
                                    validatePercentageTotals
                                  "
                                  i18n-message
                                  message="Percentage cannot exceed 100"
                                >
                                </dxi-validation-rule>
                              </dx-validator>
                            </dx-number-box>
                          </div>

                          <div class="left-card-label-value-container">
                            <div i18n="@@discountNett" class="width-label">
                              Discount (Nett):
                            </div>
                            <dx-number-box
                              class="width-value read-only"
                              [(value)]="item.discountNett"
                              format="#,##0.00 €"
                              [readOnly]="true"
                            >
                            </dx-number-box>
                          </div>
                          <div class="left-card-label-value-container">
                            <div i18n="@@discountGross" class="width-label">
                              Discount (Gross):
                            </div>
                            <dx-number-box
                              class="width-value read-only"
                              [readOnly]="
                                focusedSelection.siteCost.planIsPercentage
                              "
                              (onValueChanged)="calcOnDiscountChange(i)"
                              [(value)]="item.discountGross"
                              format="#,##0.00 €"
                            >
                            </dx-number-box>
                          </div>

                          <div class="left-card-label-value-container">
                            <div i18n="@@totalValueNet" class="width-label">
                              Total Due (Nett):
                            </div>

                            <dx-number-box
                              class="width-value read-only"
                              (onValueChanged)="onPlanCostNettChanged(i)"
                              [(value)]="item.planCostNett"
                              [readOnly]="
                                focusedSelection.siteCost.planIsPercentage
                              "
                              format="#,##0.00 €"
                            >
                              <!--        <dx-validator>
                                                              <dxi-validation-rule type="custom"
                                                                  [validationCallback]="validateNettCostTotals"
                                                                  i18n-message message="Totals don't add up">
                                                              </dxi-validation-rule>
                                                          </dx-validator> -->
                            </dx-number-box>
                          </div>

                          <div class="left-card-label-value-container">
                            <div i18n="@@totalDueGross" class="width-label">
                              Total Due (Gross):
                            </div>
                            <dx-number-box
                              class="width-value read-only"
                              [readOnly]="true"
                              (onValueChanged)="onPlanCostNettChanged(i)"
                              [(value)]="item.planCostGross"
                              format="#,##0.00 €"
                            >
                            </dx-number-box>
                          </div>
                          <div class="left-card-label-value-container">
                            <div i18n="@@dueDateType" class="width-label">
                              Due Date Type:
                            </div>

                            <div class="width-value-cost payment-type">
                              <!--                                <p i18n="@@percent" class="payment-tyoe-option-container"
                                                              (click)="dueDateTypeSwitch('date',item, i)"
                                                              [ngClass]="{'payment-type-selected': !focusedSelection.paymentPlans[i].dueDateMilestone === true, 'payment-type-deselected': !focusedSelection.paymentPlans[i].dueDateMilestone === false}">
                                                              Date</p>
                                                          <p i18n="@@euro" class="payment-tyoe-option-container"
                                                              (click)="dueDateTypeSwitch('milestone',item, i)"
                                                              [ngClass]="{'payment-type-selected': focusedSelection.paymentPlans[i].dueDateMilestone === true, 'payment-type-deselected': focusedSelection.paymentPlans[i].dueDateMilestone === false}">
                                                              Milestone</p> -->
                              <div class="switch-container">
                                <div
                                  class="switch milestone"
                                  [ngClass]="{
                                    active:
                                      focusedSelection.paymentPlans[i]
                                        .dueDateMilestone === true
                                  }"
                                  id="toggleDateSwitch"
                                  (click)="toggleDueDateSwitch(item, i)"
                                >
                                  <span i18n="@@Date">Date</span>
                                  <span i18n="@@Milestone">Milestone</span>
                                </div>
                              </div>
                            </div>
                            <!-- 
                                                      <dx-button (onClick)="setJustDueDate()" i18n-text
                                                          class="gt-button gt-tertiary gt-btn-left"
                                                          text="Due Date"></dx-button>
                                                      <dx-button (onClick)="setDueDateByMilestone()" i18n-text
                                                          class="gt-button gt-tertiary gt-btn-left"
                                                          text="Due Date By Milestone"></dx-button> -->
                          </div>

                          <div
                            *ngIf="
                              !focusedSelection.paymentPlans[i].dueDateMilestone
                            "
                            class="left-card-label-value-container"
                          >
                            <div i18n="@@dueDate:" class="width-label">
                              Due Date:
                            </div>
                            <dx-date-box
                              class="width-value"
                              type="date"
                              [(value)]="item.dueDate"
                              [openOnFieldClick]="true"
                              [inputAttr]="{ 'aria-label': 'Date' }"
                              displayFormat="dd.MM.yyyy"
                              dateSerializationFormat="yyyy-MM-dd"
                            >
                              <dx-validator>
                                <dxi-validation-rule
                                  type="required"
                                  i18n-message="@@dueDateIsRequired"
                                  message="Due Date is Required"
                                >
                                </dxi-validation-rule>
                              </dx-validator>
                            </dx-date-box>
                          </div>

                          <div
                            *ngIf="
                              focusedSelection.paymentPlans[i].dueDateMilestone
                            "
                            class="left-card-label-value-container"
                          >
                            <dx-number-box
                              width="100px"
                              [min]="0"
                              [(value)]="item.costMilestoneOffset"
                            >
                              <dx-validator
                                *ngIf="
                                  focusedSelection.paymentPlans[i]
                                    .dueDateMilestone
                                "
                              >
                                <dxi-validation-rule
                                  *ngIf="
                                    focusedSelection.paymentPlans[i]
                                      .dueDateMilestone
                                  "
                                  type="required"
                                  i18n-message="@@milestoneIsRequired"
                                  message="Milestone information is required"
                                >
                                </dxi-validation-rule>
                              </dx-validator>
                            </dx-number-box>
                            <span i18n class="form-inline-span-text"
                              >weeks</span
                            >
                            <dx-select-box
                              width="auto"
                              i18n-placeholder
                              placeholder="Before/After"
                              [dataSource]="milestoneOffsetDirections"
                              displayExpr="text"
                              valueExpr="text"
                              [(value)]="item.costMilestoneDirection"
                              [showClearButton]="true"
                            >
                              <dx-validator
                                *ngIf="
                                  focusedSelection.paymentPlans[i]
                                    .dueDateMilestone
                                "
                              >
                                <dxi-validation-rule
                                  *ngIf="
                                    focusedSelection.paymentPlans[i]
                                      .dueDateMilestone
                                  "
                                  type="required"
                                  i18n-message="@@milestoneIsRequired"
                                  message="Milestone information is required"
                                >
                                </dxi-validation-rule>
                              </dx-validator>
                            </dx-select-box>
                            <dxi-validation-rule
                              *ngIf="
                                focusedSelection.paymentPlans[i]
                                  .dueDateMilestone
                              "
                              type="required"
                              i18n-message="@@milestoneIsRequired"
                              message="Milestone information is required"
                            >
                            </dxi-validation-rule>
                            <dx-select-box
                              width="auto"
                              i18n-placeholder
                              placeholder="Select Milestone"
                              [dataSource]="milestones"
                              [dropDownOptions]="{ width: 300 }"
                              (onSelectionChanged)="changeMilestone($event)"
                              [(value)]="item.costMilestoneId"
                              valueExpr="id"
                              displayExpr="name"
                              [showClearButton]="true"
                            >
                              <dx-validator
                                *ngIf="
                                  focusedSelection.paymentPlans[i]
                                    .dueDateMilestone
                                "
                              >
                                <dxi-validation-rule
                                  *ngIf="
                                    focusedSelection.paymentPlans[i]
                                      .dueDateMilestone
                                  "
                                  type="required"
                                  i18n-message="@@milestoneIsRequired"
                                  message="Milestone information is required"
                                >
                                </dxi-validation-rule>
                              </dx-validator>
                            </dx-select-box>
                            <dxi-validation-rule
                              *ngIf="
                                focusedSelection.paymentPlans[i]
                                  .dueDateMilestone
                              "
                              type="required"
                              i18n-message="@@milestoneIsRequired"
                              message="Milestone information is required"
                            >
                            </dxi-validation-rule>
                            <span i18n class="form-inline-span-text"
                              >milestone.</span
                            >
                          </div>
                          <div
                            *ngIf="
                              focusedSelection.paymentPlans[i].dueDateMilestone &&
                              item.costMilestoneId &&
                              getMilestonePlannedDate(item.costMilestoneId)
                            "
                            class="left-card-label-value-container"
                          >
                            <span i18n="@@milestoneDate" class="form-inline-span-text">Milestone Date</span>
                            <span class="form-inline-span-text">{{ getMilestonePlannedDate(item.costMilestoneId) | date:'longDate' }}</span>
                          </div>
                        </div>

                        <div class="right-card-item-container">
                          <div i18n="@@details" class="width-label-notes">
                            Details:
                          </div>
                          <dx-text-area
                            class="width-value-notes"
                            [(value)]="item.planNotes"
                            i18n-placeholder
                            placeholder="Add Details..."
                          >
                          </dx-text-area>
                        </div>
                      </div>
                    </div>

                    <div class="payment-container">
                      <div class="payment-plan-header" i18n="@@payment">
                        Payment
                      </div>
                      <div class="card-inner-container">
                        <div class="left-card-item-container">
                          <div class="left-card-label-value-container">
                            <div i18n="@@paidAmountNett" class="width-label">
                              Paid Amount (Nett):
                            </div>
                            <dx-number-box
                              class="width-value right-card-value-label-margin read-only"
                              [(value)]="item.paidAmountNett"
                              format="#,##0.00 €"
                              [readOnly]="true"
                            >
                            </dx-number-box>
                          </div>

                          <div class="left-card-label-value-container">
                            <div i18n="@@paidAmountGross" class="width-label">
                              Paid Amount (Gross):
                            </div>
                            <dx-number-box
                              class="width-value right-card-value-label-margin read-only"
                              [(value)]="item.paidAmountGross"
                              (onValueChanged)="calcOnPaidChanged(i)"
                              format="#,##0.00 €"
                              [readOnly]="
                                focusedSelection.siteCost.planIsPercentage
                              "
                            >
                            </dx-number-box>
                          </div>

                          <div class="left-card-label-value-container">
                            <div i18n="@@paidDate" class="width-label">
                              Paid Date:
                            </div>
                            <dx-date-box
                              class="width-value right-card-value-label-margin read-only"
                              type="date"
                              [(value)]="item.paidDate"
                              [inputAttr]="{ 'aria-label': 'Date' }"
                              displayFormat="dd.MM.yyyy"
                              [openOnFieldClick]="true"
                              [readOnly]="
                                focusedSelection.siteCost.planIsPercentage
                              "
                              dateSerializationFormat="yyyy-MM-dd"
                            >
                            </dx-date-box>
                          </div>

                          <div class="left-card-label-value-container">
                            <div
                              i18n="@@outstandingAmountNet"
                              class="width-label"
                            >
                              Outstanding Amount (Nett):
                            </div>
                            <dx-number-box
                              class="width-value right-card-value-label-margin read-only"
                              [(value)]="item.dueAmountNett"
                              format="#,##0.00 €"
                              [readOnly]="true"
                            >
                            </dx-number-box>
                          </div>

                          <div class="left-card-label-value-container">
                            <div
                              i18n="@@outstandingAmountGross"
                              class="width-label"
                            >
                              Outstanding Amount (Gross):
                            </div>
                            <dx-number-box
                              class="width-value right-card-value-label-margin read-only"
                              [(value)]="item.dueAmountGross"
                              format="#,##0.00 €"
                              [readOnly]="true"
                            >
                            </dx-number-box>
                          </div>

                          <div
                            class="left-card-label-value-container"
                            *ngIf="item.documentURL"
                          >
                            <div i18n="@@costDocument" class="width-label">
                              Cost Document:
                            </div>
                            <div style="margin-top: -20px">
                              <dx-button
                                class="document-button"
                                [text]="item.documentName ?? 'OPEN'"
                                (onClick)="openDocumentURL(item.documentURL)"
                              ></dx-button>
                            </div>
                          </div>
                        </div>

                        <div class="right-card-item-container">
                          <div class="width-label-notes" i18n="@@notes">
                            Notes:
                          </div>
                          <dx-text-area
                            class="width-value-notes"
                            [(value)]="item.paymentNotes"
                            i18n-placeholder="@@addNotes"
                            placeholder="Add Notes..."
                          >
                          </dx-text-area>
                        </div>
                      </div>
                    </div>
                    <div class="zero-width">
                      <div
                        *ngIf="removePaymentPlanButtonVisible"
                        class="remove-from-array-button"
                        (click)="removePaymentPlan(i)"
                      ></div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </dxi-item>
          </dxi-item>
          <dxi-item [colSpan]="2" class="float-end">
            <div *dxTemplate="let data of 'addPaymentPlanTemplate'">
              <app-gpd-button
                type="text"
                icon="add"
                i18n-text="@@addPaymentPlan"
                text="Add Payment Plan"
                (onClick)="addNewPaymentPlan()"
                icon="add"
              >
              </app-gpd-button>
            </div>
          </dxi-item>
        </dx-form>
        <div class="pop-up-buttton-container">
          <app-gpd-button
            type="danger"
            icon="delete"
            i18n-text="@@delete"
            text="DELETE"
            (onClick)="deleteProjectCost()"
          >
          </app-gpd-button>
          <div style="display: flex; gap: 8px;">
            <app-gpd-button
              type="secondary"
              icon="cancel"
              i18n-text="@@cancel"
              text="CANCEL"
              (onClick)="goBack()"
            >
            </app-gpd-button>

            <app-gpd-button
              #saveButton
              icon="check"
              i18n-text="@@save"
              text="SAVE"
              [validationGroup]="validationGroupName"
              [useSubmitBehavior]="false"
              (onClick)="saveAdd($event)"
            >
            </app-gpd-button>
          </div>
        </div>
      </dx-validation-group>
    </form>
  </div>
</div>

<dx-popup
  [visible]="addNewPartnerPopupVisible"
  (onHiding)="addNewPartnerPopupVisible = false"
  i18n-title="@@addNewPartner"
  title="Add New Partner"
  [hideOnOutsideClick]="true"
  width="70vw"
  height="80vh"
>
  <app-contacts-add-company
    [prePopulatePartner]="true"
    (onAddPartner)="passNewPartnerId($event)"
    (onAbort)="handleAbort($event)"
  >
  </app-contacts-add-company>
</dx-popup>

<dx-popup
  [visible]="showPopup"
  (onHiding)="showPopup = false"
  i18n-caption
  [title]="popupTitle"
  [hideOnOutsideClick]="true"
  width="500px"
  height="310"
>
  <div style="display: flex; flex-direction: column; align-items: center">
    <span>{{ popupMessage }}</span>

    <div
      style="
        margin-top: 45px;
        display: flex;
        gap: 10px;
        justify-content: center;
      "
    >
      <dx-button
        i18n-text="@@no"
        text="No"
        (onClick)="showPopup = false"
        class="gt-button gt-blk-txt button-top-space add-site-icon"
        icon="clear"
        style="color: black"
      >
      </dx-button>

      <dx-button
        i18n-text="@@yes"
        text="Yes"
        (onClick)="confirmPopup('yes')"
        type="default"
        icon="check"
        class="gt-button gt-blk-txt button-top-space add-site-icon"
        style="color: black"
      >
      </dx-button>
    </div>
    <dx-check-box
      *ngIf="includeDontShowButton"
      i18n-text="@@dontShowAgain"
      text="Don't show again"
      (onValueChanged)="onDontShowChanged($event)"
      stylingMode="contained"
      style="margin-top: 45px"
    ></dx-check-box>
  </div>
</dx-popup>

<dx-toast
  [visible]="toastVisible"
  [type]="type"
  i18n-message
  [message]="message"
  position="bottom center"
>
</dx-toast>

<app-contacts-popup
  class="dx-treevieweditor-overlay"
  [(visible)]="contactsPopupVisible"
  (onHiding)="contactsPopupVisible = false"
  [(companies)]="companies"
  [(persons)]="persons"
  [tagFilter]="true"
  (onContactSelected)="onPopupContactSelected($event)"
  (onContactAdded)="onNewContactSelected($event)"
>
</app-contacts-popup>
